import { chooseObj, datePickerObj, inputObj, pickerObj } from "utils/getObjs";

const basicInformation = [
  inputObj('岗位名称', "FPOSITIONTITLE", true),
  pickerObj('职业(工种)资格', 'FPROFESSIONCODE', true),
  pickerObj('国家职业资格等级', 'FQUALLEVEL', true),
  inputObj('招聘人数', "FRECRUITSNUM", true),
  inputObj('招聘男性人数', "FMANNUM"),
  inputObj('招聘女性人数', "FWOMANNUM"),
  pickerObj('工作环境', 'FWORKENV'),
  inputObj('工作地点', "FWORKPLACE", true),
  inputObj('联系人', "FCONTACTPERSON", true),
  inputObj('联系电话', "FCONTACTNUMBER", true),
  pickerObj('工作地点行政区划', 'FAREA', true),
  pickerObj('工作性质', 'FWORKNATURE', true),
  inputObj('岗位描述', "FJOBDESCRIP", true),
];
const recruitmentRequirements = [
  pickerObj('所学专业', 'FMAJOR'),
  pickerObj('学历', 'FEDUCATION'),
  pickerObj('职称', 'FJOBTITLE'),
  pickerObj('政治面貌', 'FPOLITICALSTATUS'),
  inputObj('最低年龄', "FMINAGE"),
  inputObj('最高年龄', "FMAXAGE"),
  inputObj('身高(CM)', "FHEIGHT"),
  inputObj('体重(KG)', "FWEIGHT"),
  inputObj('视力', "FVISION"),
  inputObj('户口所在地', "FRESIDADDRESS"),
  pickerObj('外语语种', 'FLANGUAGE'),
  pickerObj('外语水平', 'FLANGUAGELEVEL'),
  pickerObj('计算机水平', 'FCOMPUTERSKILL'),
  inputObj('从业年数', "FEMPLOYYEARS"),
]
const jobTreatment = [
  inputObj('月薪下限', "FMINMONTHSALARY", true),
  inputObj('月薪上限', "FMAXMONTHSALARY", true),
  inputObj('试用期(月)', "FPROBATION"),
  pickerObj('试用期月工资档次', 'FPROBMONTHSALARY'),
  chooseObj('是否提供住宿', 'FPROVROOMLOGO'),
  chooseObj('是否提供住房公积金', 'FPROVFUNDLOGO'),
  datePickerObj('面试日期', 'FINTERVIEWDATE'),
  inputObj('面试地点', "FINTERVIEWLOCATION"),
  inputObj('其他待遇', "FOTHERTREAT"),
  datePickerObj('到期日期', 'FEXPIRYDATE', true),
]


export const recruitPage1 = [
  { title: '基本信息', arr: basicInformation },
  // { title: '招聘要求', arr: recruitmentRequirements}
  // { title: '岗位待遇', arr: jobTreatment }
]

export const recruitPage2 = [
  { title: '招聘要求', arr: recruitmentRequirements }
]

export const recruitPage3 = [
  { title: '岗位待遇', arr: jobTreatment }
]